import { useState } from "react";
import CustomDropDownMenu from "../../common/CustomDropDownMenu";
import { GetImages } from "../../../utils/GetImages";
import CustomInputs from "../../common/Inputs";
import { FORM_CONTROLFIELD_TYPES } from "../../../constants/constants";
import AddTraspButton from "../../firstTimeUserExperience/commonCom/AddTraspButton";
import AddButtonWithArrow from "../../firstTimeUserExperience/commonCom/AddButtonWithArrow";
import { Offcanvas } from "react-bootstrap";
import { CustomInputTextArea } from "../../common/formControls";
import LeftArrowTopHeader from "../../../newComponents/form-fields/LeftArrowTopHeader";
import ActionMenu from "../../../newComponents/actionMenus/action-menu";
import { useNavigate } from "react-router";
import { TextCss } from "../../GlobalCss/TextCss";
import { usePermissions } from "../../../hooks/usePermissions";

const QuestionHeader = ({ postData, setPostData, duplicateTemplete, deleteTemplete, previewApplication = false, handleSubmit = () => { } }) => {
 const navigate = useNavigate()
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState(postData);

  const check = usePermissions();
  const canWrite = check.canWrite("Templates");

  const handleSave = (e) => {
    e.preventDefault();
    setShow(false);
    setPostData({ ...editData })
  };

  const handleEditClick = () => {
    setEditData({ ...postData });
    setShow(true);
  };

  const handleCancel = () => {
    setShow(false);
  };

  
  const menuItems = [
  {
    label: "Duplicate",
    icon: GetImages.BlackCopy,
    action: () => duplicateTemplete(),
  },
  { isDivider: true },
  {
    label: "Edit",
    icon: GetImages.BlackPencil,
    action: () => handleEditClick(),
  },
  { isDivider: true },
  {
    label: "Delete",
    icon: postData?.isInUse ? GetImages.greyDelete : GetImages.BlackDelete,
    action: () => deleteTemplete(),
    textClass: postData?.isInUse ? "sub_text fw-600 grey" : "sub_text fw-600 red",
  },
];

  return (
    <>
      <div className="application-top-card">
         <div className="flexRow align-items-center justify-content-center gap-2 ">
          <LeftArrowTopHeader className={TextCss.black.heading_700_16} title={`${postData?.name}`} backPath={-1} />
            <p className="green">{postData?.isInUse ? "In use" : ""}</p>
          </div>
        {canWrite && (
          <ActionMenu
          menuItems={menuItems}
                trigger={
                  <button   
                  className="action-button" aria-label="More options">
                    <img
                      src={GetImages.dropdownIcon}
                      alt="More options"
                      width={20}
                      height={20}
                      className="action-icon"
                    />
                  </button>
                }
              />
        )}
        {/* <CustomDropDownMenu Action={true} Element={<img src={GetImages.BlueChevronDown} alt="BlueChevronDown" />} data={data} /> */}
      </div>

      <Offcanvas className="offcanvas serviceRequestForm" show={show} onHide={handleCancel} placement="end" scroll={true}>
        <Offcanvas.Header className="canvasHeader" closeButton>
          <Offcanvas.Title>Edit Basic Details</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form className="editbasicdetails needs-validation" onSubmit={handleSave}>
            <div className="flexColumn p-3 gap-4">
              <CustomInputs
                name="name"
                type={FORM_CONTROLFIELD_TYPES?.TEXT}
                value={editData?.name}
                labelText="Template Name"
                isFormControl
                required
                onChange={(e) => setEditData({ ...editData, name: e.target.value })}
                width="440px"
              />
              <CustomInputTextArea
                name="description"
                placeholder="Add Template Description here..."
                required
                label="Template Description"
                isFormControl
                value={editData?.description}
                onChange={(e) => setEditData({ ...editData, description: e.target.value })}
                myClassName="normal_text black w-100 mb-3"
                rows={5}
              />
            </div>
            <div className="editFormFooter start-0">
              <AddTraspButton type="button" bname="Cancel" onClick={handleCancel} border={false} width="fit-content" />
              <AddButtonWithArrow onClick={handleSave} buttonname="Save" type="submit" minWidth="100px" />
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default QuestionHeader;
